import { render, staticRenderFns } from "./sluggish.vue?vue&type=template&id=32c8c76c&"
import script from "./sluggish.vue?vue&type=script&lang=js&"
export * from "./sluggish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports